<template>
  <div class="modal fade" id="gamanzaRewardShopModal" tabindex="-1"
    aria-labelledby="rewardShopModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" style="background: #1a1a2e; color: white;">
        <div class="modal-header" style="border-bottom: 1px solid #333;">
          <h5 class="modal-title" id="rewardShopModalLabel">Tienda de Recompensas</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="modalOpen" :id="widgetId" class="gamification_widget" data-type="reward-shop"></div>
          <div v-else class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gamanzaWidgetService from '@/services/gamanzaWidgetService';

export default {
  name: 'GamanzaRewardShop',
  props: ['skin', 'language'],
  data() {
    return {
      modalOpen: false,
      widgetId: `gamanza-rewardshop-widget-${this._uid}`
    }
  },
  mounted() {
    const modalEl = document.getElementById('gamanzaRewardShopModal');
    if (modalEl) {
      modalEl.addEventListener('shown.bs.modal', this.onModalShown);
      modalEl.addEventListener('hidden.bs.modal', this.onModalHidden);
    }
  },
  beforeDestroy() {
    const modalEl = document.getElementById('gamanzaRewardShopModal');
    if (modalEl) {
      modalEl.removeEventListener('shown.bs.modal', this.onModalShown);
      modalEl.removeEventListener('hidden.bs.modal', this.onModalHidden);
    }
  },
  methods: {
    onModalShown() {
      this.modalOpen = true;
      this.$nextTick(() => {
        setTimeout(() => {
          gamanzaWidgetService.reloadOne(this.widgetId);
        }, 500);
      });
    },
    onModalHidden() {
      this.modalOpen = false;
      const el = document.getElementById(this.widgetId);
      if (el) {
        el.innerHTML = '';
      }
    }
  }
}
</script>

<style scoped>
.gamification_widget {
  min-height: 400px;
}
</style>
